import { render, staticRenderFns } from "./hazardInvestigationDetail.vue?vue&type=template&id=73faa2e0"
import script from "./hazardInvestigationDetail.vue?vue&type=script&lang=js"
export * from "./hazardInvestigationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73faa2e0')) {
      api.createRecord('73faa2e0', component.options)
    } else {
      api.reload('73faa2e0', component.options)
    }
    module.hot.accept("./hazardInvestigationDetail.vue?vue&type=template&id=73faa2e0", function () {
      api.rerender('73faa2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/hazardInvestigationDetail.vue"
export default component.exports